import { useState } from 'react';

import Button from 'components/Button';
import { ENUM_TYPE_REPORT_STATUS } from 'constants/enum';
import Preview from 'pages/Users/Detail/_components/RecentAnswerResultsAndVideoResults/Preview';
import { getFileSample, getMinutesAndSeconds } from 'utils/helper';

const VideoFile = require('assets/resources/VideoFile.svg').default;

const RecentExerciseVideoSelectionFileSample = ({
  isReportRegistration = false,
  dataCategory,
  dataVideoSample,
  handleRemoveVideo,
  categoryVideo,
  typeVideo,
  currentStatus,
}) => {
  const [openPreviewMedia, setOpenPreviewMedia] = useState({ isOpen: false, startIndex: 0 });
  const [uploadedFiles, setUploadedFiles] = useState([]);

  if (isReportRegistration && dataCategory === null && dataVideoSample === null) {
    return null;
  }

  const _getVideoDuration = () => {
    const { minutes, seconds } = getMinutesAndSeconds(
      getFileSample(dataVideoSample)?.fileSamples?.file_samples?.filter((file) => file.file_type === 'video')?.[0]?.duration || 0
    );
    return `参考動画（再生時間: ${minutes > 0 ? `${minutes} 分` : ''} ${seconds > 0 ? `${seconds} 秒` : ''})`;
  };

  const _handlePlayVideo = () => {
    setOpenPreviewMedia({ isOpen: true, startIndex: 0 });

    const videoFiles = dataVideoSample?.file_samples?.filter((file) => file?.file_type === 'video');

    setUploadedFiles(
      videoFiles.map((file) => {
        return { url: file?.file_url, type: 'video' };
      })
    );
  };

  const _handlePlayImage = () => {
    setOpenPreviewMedia({ isOpen: true, startIndex: 0 });

    const imageFiles = dataVideoSample?.file_samples?.filter((file) => file?.file_type === 'image');

    setUploadedFiles(
      imageFiles.map((file) => {
        return { url: file.file_url, type: 'image' };
      })
    );
  };

  return (
    <>
      <div className="flex flex-col space-y-2">
        <div className="flex items-center gap-3">
          <img src={VideoFile} alt="video" />
          <p className="font-bold">{dataVideoSample?.name_vi || dataVideoSample?.name || ''}</p>
        </div>
        <div className="flex items-center gap-3">
          <p className="">{dataVideoSample?.explain_vi || dataVideoSample?.explain || ''}</p>
        </div>
        <div>
          <ul className="list-disc pl-8">
            {(categoryVideo[dataVideoSample?.name_vi || dataVideoSample?.name] || []).map((item, index) => (
              <li className="text-sm" key={`category-video-${index}`}>
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex justify-between items-center">
          {isReportRegistration ? (
            <>
              {currentStatus === ENUM_TYPE_REPORT_STATUS.PROCESSING ? (
                <Button
                  type="button"
                  color="secondary-outline"
                  text="運動動画を取消"
                  className="!rounded-full space-x-4 px-5"
                  icon={<img src={require('assets/resources/TrashSecondary.svg').default} alt="plus icon" width={18} height={18} />}
                  onClick={() => {
                    if (isReportRegistration) {
                      handleRemoveVideo(dataVideoSample.id, typeVideo);
                    }
                  }}
                />
              ) : (
                <div></div>
              )}
              <div className="flex flex-col items-center gap-2">
                {getFileSample(dataVideoSample).hasVideo && (
                  <div className="flex items-center justify-between gap-2 w-full">
                    <p>{_getVideoDuration()}</p>
                    <img
                      className="cursor-pointer"
                      src={require('assets/resources/PlayVideoSample.svg').default}
                      alt="play icon"
                      width={24}
                      height={24}
                      onClick={_handlePlayVideo}
                    />
                  </div>
                )}
                {getFileSample(dataVideoSample).hasImage && (
                  <div className="flex items-center justify-between gap-2 w-full">
                    <p>{`参考画像（枚数: ${getFileSample(dataVideoSample)?.imageLength || 0})`}</p>
                    <img
                      className="cursor-pointer"
                      src={require('assets/resources/PlayVideoSample.svg').default}
                      alt="play icon"
                      width={24}
                      height={24}
                      onClick={_handlePlayImage}
                    />
                  </div>
                )}
              </div>
            </>
          ) : (
            <div>&nbsp;</div>
          )}
        </div>
      </div>
      {openPreviewMedia.isOpen && (
        <Preview
          media_files={uploadedFiles}
          close={() => setOpenPreviewMedia({ isOpen: false, startIndex: 0 })}
          firstOpen={openPreviewMedia.startIndex}
        />
      )}
    </>
  );
};

export default RecentExerciseVideoSelectionFileSample;
